import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Ticket, Check } from 'lucide-react';

export default function TicketTypeExamples() {
  const examples = [
    {
      name: 'Ingresso Standard',
      description: 'Accesso base all\'evento',
      price: '€20',
      zones: ['Ingresso Principale'],
      qr: { color: '#000000', bg: '#FFFFFF', logo: false }
    },
    {
      name: 'VIP Backstage',
      description: 'Accesso esclusivo backstage + ristoro',
      price: '€50',
      zones: ['Ingresso Principale', 'Backstage', 'Zona Ristoro'],
      qr: { color: '#FFD700', bg: '#000000', logo: true }
    },
    {
      name: 'Premium All-Inclusive',
      description: 'Tutti gli accessi + merchandising',
      price: '€80',
      zones: ['Tutte le zone'],
      qr: { color: '#DC2626', bg: '#FFFFFF', logo: true }
    },
    {
      name: 'Student Discount',
      description: 'Sconto studenti con documento',
      price: '€15',
      zones: ['Ingresso Principale'],
      qr: { color: '#3B82F6', bg: '#FFFFFF', logo: false }
    },
    {
      name: 'Early Bird',
      description: 'Prevendita anticipata',
      price: '€18',
      zones: ['Ingresso Principale'],
      qr: { color: '#10B981', bg: '#FFFFFF', logo: false }
    },
    {
      name: 'Staff / Press',
      description: 'Accesso gratuito staff e stampa',
      price: 'Gratuito',
      zones: ['Tutte le zone', 'Area Stampa'],
      qr: { color: '#6B7280', bg: '#F3F4F6', logo: true }
    }
  ];

  return (
    <div className="space-y-6">
      <div className="text-center mb-8">
        <Ticket className="w-16 h-16 mx-auto mb-4 text-blue-600" />
        <h2 className="text-3xl font-bold text-gray-900 mb-2">
          Esempi di Tipologie Biglietti
        </h2>
        <p className="text-gray-600 max-w-2xl mx-auto">
          Puoi creare <strong>tutte le tipologie che vuoi</strong>, ognuna con nome personalizzato, 
          prezzo diverso, accessi specifici e QR code personalizzato
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {examples.map((example, index) => (
          <Card key={index} className="hover:shadow-lg transition-shadow">
            <CardHeader>
              <CardTitle className="flex items-center justify-between">
                <span>{example.name}</span>
                <span className="text-blue-600 text-lg">{example.price}</span>
              </CardTitle>
            </CardHeader>
            <CardContent className="space-y-3">
              <p className="text-gray-600 text-sm">{example.description}</p>
              
              <div>
                <p className="text-xs font-semibold text-gray-700 mb-1">Zone di accesso:</p>
                <div className="space-y-1">
                  {example.zones.map((zone, i) => (
                    <div key={i} className="flex items-center text-xs text-gray-600">
                      <Check className="w-3 h-3 mr-1 text-green-600" />
                      {zone}
                    </div>
                  ))}
                </div>
              </div>

              <div className="pt-3 border-t border-gray-200">
                <p className="text-xs font-semibold text-gray-700 mb-2">QR Code personalizzato:</p>
                <div className="flex items-center gap-2">
                  <div 
                    className="w-8 h-8 rounded border-2"
                    style={{ 
                      backgroundColor: example.qr.bg,
                      borderColor: example.qr.color 
                    }}
                  >
                    <div 
                      className="w-full h-full flex items-center justify-center text-xs"
                      style={{ color: example.qr.color }}
                    >
                      QR
                    </div>
                  </div>
                  <span className="text-xs text-gray-600">
                    {example.qr.logo ? 'Con logo' : 'Senza logo'}
                  </span>
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>

      <Card className="bg-blue-50 border-blue-200">
        <CardContent className="p-6">
          <h3 className="font-semibold text-blue-900 mb-2">💡 Ricorda:</h3>
          <ul className="space-y-2 text-sm text-blue-800">
            <li>• Non c'è limite al numero di tipologie che puoi creare</li>
            <li>• Ogni tipologia può avere un nome completamente personalizzato</li>
            <li>• Puoi modificare prezzi e disponibilità in qualsiasi momento</li>
            <li>• Ogni tipologia può accedere a zone diverse dell'evento</li>
            <li>• I QR code possono essere personalizzati con colori e logo diversi per ogni tipologia</li>
          </ul>
        </CardContent>
      </Card>
    </div>
  );
}
